import { initializeRecentAttachmentPillsView } from '../actions/internalActions';
import createAttachmentsPillData from '../utils/createAttachmentsPillData';
import { mutator } from 'satcheljs';
import { getStore } from '../store/store';

mutator(initializeRecentAttachmentPillsView, actionMessage => {
    const store = getStore();

    store.recentAttachmentPills.set(actionMessage.composeId, {
        isExpanded: false,
        displayPills: true,
        hasLoggedShowExpandButton: false,
        numberOfRecipients: actionMessage.numberOfRecipients,
        recipientName: actionMessage.recipientName,
        attachmentsPillData: createAttachmentsPillData(actionMessage.attachments!),
        showExpandButton: false,
    });
});
